import { put, call, takeLatest } from 'redux-saga/effects';
import { FUNCTION } from '../constants';
import * as actions from '../actions';
import { queryFunction } from '../api';

export default function* watchAccount() {
    yield takeLatest(FUNCTION.FUNCTION_QUERY, functionSaga)
}

export function* functionSaga(action) {
    try {
        yield put(actions.queryFunctionLoad());
        const resultJson = yield call(queryFunction, action.formData);
        const token = "";//resultJson.token;
        const result = resultJson.result;
        yield put(actions.queryFunctionSuccess(token, result));
    } catch (error) {
        console.error(error);
    }
}